import axios from 'axios'
import { Message } from 'element-ui'

// 创建axios实例
const service = axios.create({
  baseURL: 'https://be.icoldchain.cn/', // api的base_url
  timeout: 600000, // 请求超时时间
  withCredentials: false
})
// Add a request interceptor
service.interceptors.request.use(function(config) {
  // Do something before request is sent
  return config
}, function(error) {
  // Do something with request error
  return Promise.reject(error)
})
// Add a response interceptor
service.interceptors.response.use(function(response) {
  // Do something with response data
  if (response.data.code !== 200) {
    console.log('错误')
    console.log(response)
    Message({
      message: response.data.message,
      type: 'error',
      duration: 2 * 1000
    })
    return Promise.reject('服务器接口返回失败')
  }
  return response
}, function(error) {
  // Do something with response error
  return Promise.reject(error)
})
export default service
